export default __webpack_public_path__ + "static/media/productScreenshot.16cfa600.png";